import { useQuery } from '@tanstack/react-query';
import ms from 'ms';

import { type FilterTypes } from 'hb-react/frontoffice/apps/Filters/constants/FilterTypes';
import { type FiltersBlocks } from 'hb-react/frontoffice/apps/Filters/types/filter';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const USERS_TYPE = 'users';

export interface TopFilter {
  attribute_name: string;
  display: boolean;
  label: string;
  name: string;
  options: Array<string>;
  placeholder: string;
  query: string;
  section_id: string;
  type: FilterTypes;
}

interface UseGetUsersFiltersResponse {
  overlay: FiltersBlocks;
  top: Array<TopFilter>;
}

export const useGetUsersFilters = (topicId?: number) =>
  useQuery<UseGetUsersFiltersResponse>({
    queryKey: ['notify-people-filters', USERS_TYPE, topicId],
    queryFn: () =>
      axios
        .get(
          Routes.private_frontoffice_users_notify_people_fields_path(
            topicId
              ? {
                  topic_id: topicId,
                }
              : {},
          ),
        )
        .then(({ data }) => data)
        .catch((error) => {
          throw new Error(error);
        }),
    staleTime: ms('10m'),
  });
